import type { Conversation } from './types';

/** Query string for a thread: DM uses other user's id + group=0; group uses conversation id + group=1. */
export function getMessageThreadSearch(c: Conversation): string {
  const group = c.is_group ? 1 : 0;
  const userid = c.is_group ? c.id : c.other_user_id ?? c.id;
  return `?userid=${userid}&group=${group}`;
}

export function getMessageThreadPath(c: Conversation): string {
  return `/message${getMessageThreadSearch(c)}`;
}

export function parseMessageThreadQuery(search: string): {
  userid: number;
  group: 0 | 1;
} | null {
  const params = new URLSearchParams(search);
  const rawUser = params.get('userid');
  const rawGroup = params.get('group');
  if (rawUser == null || rawUser === '') return null;
  const userid = Number(rawUser);
  if (!Number.isFinite(userid) || userid <= 0) return null;
  const group: 0 | 1 = rawGroup === '1' || rawGroup === 'true' ? 1 : 0;
  return { userid, group };
}

export function findConversationByThreadQuery(
  conversations: Conversation[],
  userid: number,
  group: 0 | 1,
): Conversation | undefined {
  if (group === 1) {
    return conversations.find((c) => c.is_group && c.id === userid);
  }
  return conversations.find(
    (c) =>
      !c.is_group &&
      (c.other_user_id === userid || (c.other_user_id == null && c.id === userid)),
  );
}
